var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOffCampusContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.578,
    height: 29.911,
    viewBox: "0 0 36.578 29.911",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#666;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-182.285 -232.757)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M84.253,0h-31.1c-.732,0-1.325.392-1.325.876V4.732h-1.5c-.732,0-1.325.392-1.325.876s.593.876,1.325.876h1.5V9.406h-1.5c-.732,0-1.325.392-1.325.876s.593.876,1.325.876h1.5v2.921h-1.5c-.732,0-1.325.392-1.325.876s.593.876,1.325.876h1.5v2.921h-1.5c-.732,0-1.325.392-1.325.876s.593.876,1.325.876h1.5v2.921h-1.5c-.732,0-1.325.392-1.325.876s.593.876,1.325.876h1.5v3.856c0,.484.593.876,1.325.876h31.1c.732,0,1.325-.392,1.325-.876V.876C85.578.392,84.985,0,84.253,0ZM82.928,28.158H54.478V25.179h1.5c.732,0,1.325-.392,1.325-.876s-.593-.876-1.325-.876h-1.5V20.505h1.5c.732,0,1.325-.392,1.325-.876s-.593-.876-1.325-.876h-1.5V15.832h1.5c.732,0,1.325-.392,1.325-.876s-.593-.876-1.325-.876h-1.5V11.158h1.5c.732,0,1.325-.392,1.325-.876s-.593-.876-1.325-.876h-1.5V6.485h1.5c.732,0,1.325-.392,1.325-.876s-.593-.876-1.325-.876h-1.5V1.753h28.45Z",
    transform: "translate(133.285 232.757)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M177,154.05a1.147,1.147,0,1,0,2.294,0c0-3.044,1.859-6.193,4.97-6.193s4.97,3.149,4.97,6.193a1.147,1.147,0,1,0,2.294,0,8.882,8.882,0,0,0-3.766-7.474,5.429,5.429,0,1,0-6.995,0A8.883,8.883,0,0,0,177,154.05Zm4.129-11.622a3.135,3.135,0,1,1,3.135,3.135A3.138,3.138,0,0,1,181.129,142.429Z",
    transform: "translate(17.854 101.03)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffCampusContact);
export default __webpack_public_path__ + "static/media/off-campus-contact.5e3f5d68408e86ff9a57104023ed78a5.svg";
export { ForwardRef as ReactComponent };